import styled from "styled-components";

export const SkillsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  background: ${({ light }) => (light ? "white" : "#0a0806")};
`;

export const SkillsTitle = styled.h1`
  padding: 95px 0 20px 0;
  color: ${({ light }) => (light ? " #c62828" : " #52b2bf")};
  font-size: 80px;
  margin-bottom: 20px;
  letter-spacing: 0.5px;
  font-family: Cambria, Cochin, Georgia, Times, "Times New Roman", serif;
  text-align: center;

  @media screen and (max-width: 820px) {
    margin-bottom: 20px;
    font-size: 50px;

    @media screen and (max-width: 375px) {
      margin-bottom: 20px;
      font-size: 40px;
    }
  }
`;

export const SkillsAptitudes = styled.div`
  margin-top: 20px;
  display: grid;
  padding: 30px;
`;

export const SkillsAptitudesTec = styled.div`
  margin-bottom: 20px;
  margin-top: 40px;
  display: grid;
  grid-template-columns: repeat(3, 400px);
  justify-content: center;

  @media screen and (max-width: 1300px) {
    display: grid;
    grid-template-columns: repeat(auto-fill, 400px);
    @media screen and (max-width: 960px) {
      margin-bottom: 20px;
      margin-top: 40px;
      margin-right: 20px;
      display: grid;
      justify-content: center;
      grid-template-columns: repeat(auto-fill, 320px);
    }
  }
`;

export const SkillsAptitudCard = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  margin-top: 20px;
  border: 2px solid ${({ light }) => (light ? "#e57373" : "#497e76")};
  border-radius: 15px;
  background: #272727;
`;

export const SkillsAptitudItem = styled.div`
  display: flex;
  margin-top: 5px;
`;

export const SkillsAptitudImage = styled.img`
  padding: 60px;
  width: 100%;
  position: relative;
  align-items: center;
`;

export const SkillsAptitudNameTec = styled.h1`
  color: white;
  color: #f7f8fa;
  font-size: 18px;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  text-align: center;
  display: flex;
  align-items: center;
`;

export const SkillsAptitudImageTec = styled.img`
  width: 10%;
  margin-left: 15px;
`;

export const SkillsAptitudCardTitle = styled.h2`
  text-align: Center;
  color: ${({ light }) => (light ? "#e57373" : "#497e76")};
  margin-bottom: 15px;
`;
